// frontend/src/components/librarian/ui/LibKicker.tsx
import React from 'react';

/**
 * Section label. `num` is optional and belongs only where the content is a real
 * ordered sequence (form wizard steps, sidebar nav groups) -- not on page
 * headers, where it numbered things that have no order.
 */
interface Props { num?: string; label: string; className?: string }

const LibKicker: React.FC<Props> = ({ num, label, className = '' }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    {num && (
      <span className="font-mono text-[11px] font-normal text-[var(--lib-gold-text)]">{num}</span>
    )}
    <span className="flex-1 h-px bg-[var(--lib-gold)] opacity-60" />
    <span className="font-mono text-[11px] uppercase tracking-wider text-[var(--lib-ink-muted)]">
      {label}
    </span>
  </div>
);

export default LibKicker;
